import React from "react";
import { createHashRouter, Navigate } from "react-router-dom";
import ErrorBoundary from "./components/error-boundary";
import App from "./App";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Products from "./pages/Products";
import Solutions from "./pages/Solutions";
import Technology from "./pages/Technology";
import NotFound from "./pages/NotFound";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Api from "@/pages/api";
import AccountLayout from "./pages/account/AccountLayout";
import Overview from "./pages/account/Overview";
import Subscription from "./pages/account/Subscription";
import Devices from "./pages/account/Devices";
import Placeholder from "./pages/account/Placeholder";

const routerConfig = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/technology",
    element: <Technology />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/api-doc",
    element: <Api />,
  },
  {
    path: "/account",
    element: <AccountLayout />,
    children: [
      { index: true, element: <Navigate to="/account/overview" replace /> },
      { path: "overview", element: <Overview /> },
      { path: "subscription", element: <Subscription /> },
      { path: "devices", element: <Devices /> },
      { path: "security", element: <Placeholder /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const router = createHashRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <ErrorBoundary />,
    children: routerConfig,
  },
]);

export default router;
